import { GET_STATS_SUCCESS, REQUEST, FAILURE } from "../types/statistics";

export const getStatistics = ({ token, dateTo, dateFrom }) => {
  return (dispatch) => {
    dispatch({ type: REQUEST });
    fetch(
      `https://shopngo.herokuapp.com/api/tasks/history/stats?dateFrom=${dateFrom}&dateTo=${dateTo}`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
      }
    )
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        if (res.errors) {
          dispatch({
            type: FAILURE,
            value: res.errors.status,
          });
        } else {
          dispatch({ type: GET_STATS_SUCCESS, value: res });
        }
      })
      .catch((error) => console.log(error));
  };
};
